import RuleSelector from './RuleSelector';

export default RuleSelector;
